import Trans from 'next-translate/Trans'
import useTranslation from 'next-translate/useTranslation'
import { useState } from 'react'
import { GInput } from 'tennders-common/form/components'
import useSocket from 'tennders-common/hooks/useSocket'
import { apiPost } from 'tennders-stracture/libs/api'
import { useToast } from 'tennders-common/hooks/useToast'
import GModal from 'tennders-market/common/components/element/GModal'
import GHref from 'tennders-market/common/components/element/GHref'

const MRejectAssign = ({ isOpen, close, transaction, ...rest }) => {
  const [body, setbody] = useState('')
  const [submitting, setsubmitting] = useState(false)
  const { toastSuccess } = useToast()
  const { t } = useTranslation()
  const { setRefresh } = useSocket()

  const reject = async (e) => {
    if (submitting) {
      return
    }
    if (e) {
      e.preventDefault()
    }
    setsubmitting(true)
    await apiPost(`transactions/${transaction?.id}/reject`, { body })
    setbody('')
    setsubmitting(false)
    toastSuccess(t('transaction:assignRejected'))
    setRefresh('all')
    close()
  }

  return (

    <GModal size="80%" isOpen={isOpen} close={close} {...rest}>

      <div className="tennders-modal-body w-100">

        <h4 className="bold mb-24" style={{ color: 'black' }}><Trans i18nKey="transaction:rejectReasonTitle" /></h4>
        {' '}
        <form action="tennders-transactions/modal/MRejectAssign" className="mb-10">
          <GInput
            onSet={setbody}
            val={body}
            type="textarea"
            className="form-textarea"
            placeholder={t('transaction:rejectReasonPlaceHolder')}
          />
        </form>
        <div className="d-flex align-center justify-center">
          <GHref
            disabled={body.length < 1}
            submitting={submitting}
            onClick={() => {
              reject(); if (rest.closeTransaction) {
                rest.closeTransaction()
              }
            }}
            className="btn standard-btn mr-8"
          >
            <Trans i18nKey="tableRow:reject" />
          </GHref>
          <GHref
            onClick={close}
            className="btn-border standard-btn"
          >
            <Trans i18nKey="common:cancel" />
          </GHref>
        </div>
      </div>

    </GModal>

  )
}

export default MRejectAssign
